import { AxiosError } from "axios";

import { portalRoutes } from "@/router/routes/portalRoutes";
import {
  ChangeTwoFactorAuthenticationMethod,
  ValidateTwoFactorAuthenticationMethod,
} from "@/services/model";

/** Where the 2FA change flow continues once the current method's code is verified. */
export const change2faRouteByMethod: Partial<
  Record<ValidateTwoFactorAuthenticationMethod, string>
> = {
  [ValidateTwoFactorAuthenticationMethod.APP]:
    portalRoutes.user.security.change2faApp,
  [ValidateTwoFactorAuthenticationMethod.SMS]:
    portalRoutes.user.security.change2faSms,
};

/** Where switching to another 2FA method continues from a change screen. */
export const switch2faRouteByMethod: Record<
  ChangeTwoFactorAuthenticationMethod,
  string
> = {
  [ChangeTwoFactorAuthenticationMethod.APP]:
    portalRoutes.user.security.setup2faApp,
  [ChangeTwoFactorAuthenticationMethod.SMS]:
    portalRoutes.user.security.setup2faSms,
  [ChangeTwoFactorAuthenticationMethod.STANDARD]:
    portalRoutes.user.security.confirmStandard,
};

/** Where the first 2FA setup continues for the chosen method. */
export const initial2faSetupRouteByMethod: Record<
  ChangeTwoFactorAuthenticationMethod,
  string
> = {
  [ChangeTwoFactorAuthenticationMethod.APP]:
    portalRoutes.user.security.initialAppSetup,
  [ChangeTwoFactorAuthenticationMethod.SMS]:
    portalRoutes.user.security.initialSmsSetup,
  [ChangeTwoFactorAuthenticationMethod.STANDARD]:
    portalRoutes.user.security.base,
};

export const errorShouldBeRetried: (error: AxiosError<any>) => boolean = (
  error,
) => {
  console.log(
    error.response?.data?.errorCode === 403 &&
      !(error.response?.data?.message || "").includes(
        "Die eingegebene Rufnummer ist ungültig",
      ),
  );

  return (
    (error.response?.status === 400 &&
      error.response?.data?.errorCode === 403 &&
      !(error.response?.data?.message || "").includes(
        "Die eingegebene Rufnummer ist ungültig",
      )) ||
    (error.response?.status === 500 &&
      error.response?.data.includes(
        "TwoFactorAuthentication change in progress",
      ))
  );
};
